import axios from 'axios'
import * as api_config from '../config/api_config'

export default {
  getVariant(id, params) {
    return axios.get(`${api_config.ADDRESS}/variants/${id}`, { params, headers: api_config.HEADERS })
  }
}
